import { INBOX_TYPES } from 'dashboard/helper/inbox';

// Conteúdo de exemplo das telas vazias do Agente de IA. Nada aqui é salvo: é a prévia
// desfocada que aparece atrás do aviso "nenhum registro ainda", para a tela vazia mostrar
// como fica quando estiver preenchida. Escrito em português e com exemplos de atendimento
// brasileiro, porque é a primeira coisa que o cliente vê ao abrir o módulo.

export const assistantsList = [
  {
    account_id: 2,
    config: { product_name: 'Recepção' },
    created_at: 1736033561,
    description:
      'Responde as dúvidas mais comuns de quem chega pelo WhatsApp, entende o que a pessoa precisa e passa para a equipe quando é hora de falar com alguém.',
    id: 4,
    name: 'Atendente da Recepção',
  },
  {
    account_id: 3,
    config: { product_name: 'Comercial' },
    created_at: 1736033562,
    description:
      'Qualifica o lead novo, descobre a especialidade procurada e a origem, aplica as etiquetas e deixa o card pronto no funil.',
    id: 5,
    name: 'Qualificador de Leads',
  },
  {
    account_id: 4,
    config: { product_name: 'Orçamentos' },
    created_at: 1736033563,
    description:
      'Explica valores, formas de pagamento e prazos a partir da tabela cadastrada, e chama o vendedor quando o cliente pede desconto.',
    id: 6,
    name: 'Agente de Orçamentos',
  },
  {
    account_id: 5,
    config: { product_name: 'Agenda' },
    created_at: 1736033564,
    description:
      'Confirma presença, oferece horários livres e cuida de remarcação e cancelamento, consultando o sistema de agenda da empresa.',
    id: 7,
    name: 'Agente de Agendamento',
  },
  {
    account_id: 6,
    config: { product_name: 'Pós-venda' },
    created_at: 1736033565,
    description:
      'Acompanha quem já comprou, envia lembretes de retorno e recolhe a avaliação do atendimento.',
    id: 8,
    name: 'Agente de Pós-venda',
  },
  {
    account_id: 8,
    config: { product_name: 'Financeiro' },
    created_at: 1736033567,
    description:
      'Responde sobre boleto, nota fiscal e segunda via, e encaminha para o financeiro os casos que precisam de análise.',
    id: 10,
    name: 'Suporte Financeiro',
  },
];

export const documentsList = [
  {
    assistant: { id: 1, name: 'Atendente da Recepção' },
    content:
      'Horário de funcionamento, endereço, estacionamento e como chegar. Inclui o que fazer quando o cliente chega fora do horário.',
    created_at: 1736283320,
    external_link: 'https://suaempresa.com.br/ajuda/horarios-e-endereco',
    id: 21,
    name: 'Horários, endereço e como chegar',
    status: 'available',
  },
  {
    assistant: { id: 2, name: 'Qualificador de Leads' },
    content:
      'Lista das especialidades atendidas, o que cada uma resolve e quais perguntas ajudam a identificar a especialidade certa.',
    created_at: 1736283321,
    external_link: 'https://suaempresa.com.br/ajuda/especialidades',
    id: 22,
    name: 'Especialidades atendidas',
    status: 'available',
  },
  {
    assistant: { id: 3, name: 'Agente de Orçamentos' },
    content:
      'Tabela de preços por serviço, formas de pagamento, parcelamento e regra de desconto que exige aprovação do vendedor.',
    created_at: 1736283322,
    external_link: 'https://suaempresa.com.br/ajuda/precos-e-pagamento',
    id: 23,
    name: 'Tabela de preços e formas de pagamento',
    status: 'available',
  },
  {
    assistant: { id: 4, name: 'Agente de Agendamento' },
    content:
      'Como agendar, remarcar e cancelar, com prazo mínimo de aviso e o que acontece em caso de falta.',
    created_at: 1736283323,
    external_link: 'https://suaempresa.com.br/ajuda/agendamento',
    id: 24,
    name: 'Regras de agendamento e remarcação',
    status: 'available',
  },
  {
    assistant: { id: 5, name: 'Agente de Pós-venda' },
    content:
      'Orientações de preparo e de cuidados após o atendimento, com o que o cliente precisa levar no dia.',
    created_at: 1736283324,
    external_link: 'https://suaempresa.com.br/ajuda/preparo-e-cuidados',
    id: 25,
    name: 'Preparo e cuidados do cliente',
    status: 'available',
  },
  {
    assistant: { id: 6, name: 'Suporte Financeiro' },
    content:
      'Segunda via de boleto, emissão de nota fiscal, reembolso e prazos de cada um.',
    created_at: 1736283325,
    external_link: 'https://suaempresa.com.br/ajuda/financeiro',
    id: 26,
    name: 'Boleto, nota fiscal e reembolso',
    status: 'available',
  },
];

export const responsesList = [
  {
    account_id: 1,
    answer:
      'Atendemos de segunda a sexta, das 8h às 19h, e aos sábados das 8h às 12h. Fora desse horário, sua mensagem fica registrada e respondemos na abertura.',
    created_at: 1736283330,
    id: 87,
    question: 'Qual é o horário de atendimento?',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'Recepção' },
      created_at: 1736033280,
      description:
        'Responde as dúvidas mais comuns de quem chega pelo WhatsApp.',
      id: 1,
      name: 'Atendente da Recepção',
    },
  },
  {
    account_id: 2,
    answer:
      'O valor da primeira consulta é R$ 250, com retorno em até 30 dias sem custo. Para os demais serviços, consulte a tabela ou peça que eu chamo alguém do comercial.',
    created_at: 1736283340,
    id: 88,
    question: 'Quanto custa a primeira consulta?',
    status: 'approved',
    assistant: {
      account_id: 2,
      config: { product_name: 'Orçamentos' },
      created_at: 1736033281,
      description:
        'Explica valores e formas de pagamento a partir da tabela cadastrada.',
      id: 2,
      name: 'Agente de Orçamentos',
    },
  },
  {
    account_id: 3,
    answer:
      'Dá para remarcar até 24 horas antes, sem custo. Me diga o melhor dia e eu ofereço os horários livres.',
    created_at: 1736283350,
    id: 89,
    question: 'Consigo remarcar meu horário?',
    status: 'approved',
    assistant: {
      account_id: 3,
      config: { product_name: 'Agenda' },
      created_at: 1736033282,
      description: 'Cuida de agendamento, remarcação e cancelamento.',
      id: 3,
      name: 'Agente de Agendamento',
    },
  },
  {
    account_id: 4,
    answer:
      'Aceitamos Pix, cartão em até 12 vezes e boleto. O parcelamento acima de 6 vezes passa por aprovação.',
    created_at: 1736283360,
    id: 90,
    question: 'Quais formas de pagamento vocês aceitam?',
    status: 'pending',
    assistant: {
      account_id: 4,
      config: { product_name: 'Orçamentos' },
      created_at: 1736033283,
      description: 'Explica valores, formas de pagamento e prazos.',
      id: 4,
      name: 'Agente de Orçamentos',
    },
  },
  {
    account_id: 5,
    answer:
      'Sim. Traga um documento com foto e, se for retorno, o relatório do último atendimento.',
    created_at: 1736283370,
    id: 91,
    question: 'Preciso levar algum documento?',
    status: 'approved',
    assistant: {
      account_id: 5,
      config: { product_name: 'Recepção' },
      created_at: 1736033284,
      description: 'Orienta o cliente sobre o dia do atendimento.',
      id: 5,
      name: 'Atendente da Recepção',
    },
  },
  {
    account_id: 6,
    answer:
      'Emitimos a segunda via na hora. Me confirme o CPF do titular que eu envio o boleto atualizado aqui mesmo.',
    created_at: 1736283380,
    id: 92,
    question: 'Como peço a segunda via do boleto?',
    status: 'pending',
    assistant: {
      account_id: 6,
      config: { product_name: 'Financeiro' },
      created_at: 1736033285,
      description: 'Responde sobre boleto, nota fiscal e segunda via.',
      id: 6,
      name: 'Suporte Financeiro',
    },
  },
];

export const inboxes = [
  {
    id: 7,
    name: 'E-mail do financeiro',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'financeiro@suaempresa.com.br',
  },
  {
    id: 1,
    name: 'Chat do site',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'Facebook da empresa',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: 'SMS de lembrete',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'WhatsApp da recepção',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+5511999990000',
  },
  {
    id: 8,
    name: 'Telegram do suporte',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'Canal LINE',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'Integração por API',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: 'SMS do comercial',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+5511988887777',
  },
];
